// (A) 중립 TimePicker API — antd 미접촉. (B) PlainTimePicker(native input)에 위임.
// ⚠ 값 계약은 문자열(HH:mm, native time input).
import type { CSSProperties } from 'react'
import { PlainTimePicker } from '../_impl/PlainTimePicker'

export interface OmwTimePickerProps {
  /** 문자열 값(HH:mm). 빈 문자열/undefined = 미선택. */
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  style?: CSSProperties
}

export function OmwTimePicker(props: OmwTimePickerProps) {
  return <PlainTimePicker {...props} />
}
